var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.02002H1V14.99H5V9.02002Z",
    fill: "#171923",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89 6.11V13.88H7.11V6.11H8.89ZM10 5H6V14.98H10V5Z",
    fill: "#171923",
    fillOpacity: 0.87
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.89 2.12001V13.88H12.11V2.12001H13.89ZM15 1.01001H11V14.99H15V1.01001Z",
    fill: "#171923",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasy);
export default __webpack_public_path__ + "static/media/Easy.f5036de15a874c5e5011c141e01e8abf.svg";
export { ForwardRef as ReactComponent };